import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class CustomNotificationNotification extends Notification {
  icon() {
    return 'fas fa-bullhorn';
  }
  href() {
    const content = this.attrs.notification.content() || {};
    return content.url || '/';
  }
  content() {
    const content = this.attrs.notification.content() || {};
    return content.title || 'Notificación';
  }
  excerpt() {
    const content = this.attrs.notification.content() || {};
    return content.description || '';
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/notifications/CustomNotificationNotification', CustomNotificationNotification);